import productService from '../../../../services/products';

function getChangeDimension(item) {
  if (productService.isSection(item)) {
    return 'width';
  }
}
export default { getChangeDimension };
